/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気設備情報
 */
export interface Sgkb575aResElecSetsubiInfo {
    /** 
     * 電力会社エリア：半角数字
     */
    denryokugaishaArea?: string;
    /** 
     * 電力会社エリア名称：全角半角混在
     */
    denryokugaishaAreaMeisho?: string;
    /** 
     * 供給地点特定番号：半角英数混在
     */
    suppntSpno?: string;
    /** 
     * 受付メッセージ（１）（区分）：半角英数混在
     */
    uketsukemessage1Div?: string;
    /** 
     * 受付メッセージ（１）（区分）名称：全角半角混在
     */
    uketsukemessage1Divaname?: string;
    /** 
     * 受付メッセージ（２）（区分）：半角英数混在
     */
    uketsukemessage2Div?: string;
    /** 
     * 受付メッセージ（２）（区分）名称：全角半角混在
     */
    uketsukemessage2Divaname?: string;
    /** 
     * 受付メッセージ（３）（区分）：半角英数混在
     */
    uketsukemessage3Div?: string;
    /** 
     * 受付メッセージ（３）（区分）名称：全角半角混在
     */
    uketsukemessage3Divaname?: string;
    /** 
     * 受付メッセージ（４）（区分）：半角英数混在
     */
    uketsukemessage4Div?: string;
    /** 
     * 受付メッセージ（４）（区分）名称：全角半角混在
     */
    uketsukemessage4Divaname?: string;
    /** 
     * 受付メッセージ（５）（区分）：半角英数混在
     */
    uketsukemessage5Div?: string;
    /** 
     * 受付メッセージ（５）（区分）名称：全角半角混在
     */
    uketsukemessage5Divaname?: string;
    /** 
     * 受付メッセージ（６）（区分）：半角英数混在
     */
    uketsukemessage6Div?: string;
    /** 
     * 受付メッセージ（６）（区分）名称：全角半角混在
     */
    uketsukemessage6Divaname?: string;
    /** 
     * 受付メッセージ（７）（区分）：半角英数混在
     */
    uketsukemessage7Div?: string;
    /** 
     * 受付メッセージ（７）（区分）名称：全角半角混在
     */
    uketsukemessage7Divaname?: string;
    /** 
     * 受付メッセージ（８）（区分）：半角英数混在
     */
    uketsukemessage8Div?: string;
    /** 
     * 受付メッセージ（８）（区分）名称：全角半角混在
     */
    uketsukemessage8Divaname?: string;
    /** 
     * 受付メッセージ（９）（区分）：半角英数混在
     */
    uketsukemessage9Div?: string;
    /** 
     * 受付メッセージ（９）（区分）名称：全角半角混在
     */
    uketsukemessage9Divaname?: string;
    /** 
     * 受付メッセージ（１０）（区分）：半角英数混在
     */
    uketsukemessage10Div?: string;
    /** 
     * 受付メッセージ（１０）（区分）名称：全角半角混在
     */
    uketsukemessage10Divaname?: string;
    /** 
     * 小売事業者コード：半角英数混在
     */
    genKeiyakuKoriCd?: string;
    /** 
     * 最終更新者（区分）：半角英数混在
     */
    saishuKoshinKbn?: string;
    /** 
     * 最終更新者（区分）名称：全角半角混在
     */
    saishuKoshinKbnMeisho?: string;
    /** 
     * 最終更新日時：日付YYYYMMDD
     */
    lastUpdateTime?: string;
    /** 
     * ユニバーサルサービス対象：半角英数混在
     */
    universalServiceTaisho?: string;
    /** 
     * ユニバーサルサービス対象名称：全角半角混在
     */
    universalServiceTaishoMeisho?: string;
    /** 
     * 契約形態・他契約形態：半角英数混在
     */
    keiyakuKeitaiTaKeiyakuKeitai?: string;
    /** 
     * 契約形態・他契約形態名称：全角半角混在
     */
    keiyakuKeitaiTaKeiyakuKeitaiMeisho?: string;
    /** 
     * 接続送電サービスメニュー：半角英数混在
     */
    setsuzokuSodenServiceMenu?: string;
    /** 
     * 接続送電サービスメニュー名称：全角半角混在
     */
    setsuzokuSodenServiceMenuMeisho?: string;
    /** 
     * 契約決定方法：半角英数混在
     */
    keiyakuKetteiHoho?: string;
    /** 
     * 契約決定方法名称：全角半角混在
     */
    keiyakuKetteiHohoMeisho?: string;
    /** 
     * 契約電流（区分）：半角英数混在
     */
    keiyakuDenryuKbn?: string;
    /** 
     * 契約電流（区分）名称：全角半角混在
     */
    keiyakuDenryuKbnMeisho?: string;
    /** 
     * 契約電流上限値（区分）：半角英数混在
     */
    keiyakuDenryuJogenchiKbn?: string;
    /** 
     * 契約電流上限値（区分）名称：全角半角混在
     */
    conampaJogenchiDivaname?: string;
    /** 
     * アンペアブレーカー有無・遠隔操作有無：半角英数混在
     */
    ampereBreakerEnkakuSosaUmu?: string;
    /** 
     * アンペアブレーカー有無・遠隔操作有無名称：全角半角混在
     */
    ampereBreakerEnkakuSosaUmuMeisho?: string;
    /** 
     * 契約容量：半角数値(小数点あり)
     */
    conCapKva?: number;
    /** 
     * 契約電力（容量・電流）単位：半角英数混在
     */
    keiyakuDenryokuTani?: string;
    /** 
     * 契約電力（容量・電流）単位名称：全角半角混在
     */
    keiyakuDenryokuTaniMeisho?: string;
    /** 
     * 最低料金制適用：半角英数混在
     */
    saiteiRyokinseiTekiyo?: string;
    /** 
     * 最低料金制適用名称：全角半角混在
     */
    saiteiRyokinseiTekiyoMeisho?: string;
    /** 
     * 電流制限値（区分）：半角英数混在
     */
    denryuSeigenchiKbn?: string;
    /** 
     * 電流制限値（区分）名称：全角半角混在
     */
    denryuSeigenchiDivaname?: string;
    /** 
     * 契約電力：半角数値(小数点あり)
     */
    conEleKw?: number;
    /** 
     * 力率：半角数値(小数点なし)
     */
    powerPrcent?: number;
    /** 
     * 定額電灯（１）（ランク）：半角数字
     */
    teigakudento1Rank?: string;
    /** 
     * 定額電灯（１）（電灯）：半角数値(小数点なし)
     */
    teigakudento1Dento?: number;
    /** 
     * 定額電灯（１）（小型機器）：半角数値(小数点なし)
     */
    teigakudento1Kogatakiki?: number;
    /** 
     * 定額電灯（２）（ランク）：半角数字
     */
    teigakudento2Rank?: string;
    /** 
     * 定額電灯（２）（電灯）：半角数値(小数点なし)
     */
    teigakudento2Dento?: number;
    /** 
     * 定額電灯（２）（小型機器）：半角数値(小数点なし)
     */
    teigakudento2Kogatakiki?: number;
    /** 
     * 定額電灯（３）（ランク）：半角数字
     */
    teigakudento3Rank?: string;
    /** 
     * 定額電灯（３）（電灯）：半角数値(小数点なし)
     */
    teigakudento3Dento?: number;
    /** 
     * 定額電灯（３）（小型機器）：半角数値(小数点なし)
     */
    teigakudento3Kogatakiki?: number;
    /** 
     * 定額電灯（４）（ランク）：半角数字
     */
    teigakudento4Rank?: string;
    /** 
     * 定額電灯（４）（電灯）：半角数値(小数点なし)
     */
    teigakudento4Dento?: number;
    /** 
     * 定額電灯（４）（小型機器）：半角数値(小数点なし)
     */
    teigakudento4Kogatakiki?: number;
    /** 
     * 定額電灯（５）（ランク）：半角数字
     */
    teigakudento5Rank?: string;
    /** 
     * 定額電灯（５）（電灯）：半角数値(小数点なし)
     */
    teigakudento5Dento?: number;
    /** 
     * 定額電灯（５）（小型機器）：半角数値(小数点なし)
     */
    teigakudento5Kogatakiki?: number;
    /** 
     * 定額電灯（６）（ランク）：半角数字
     */
    teigakudento6Rank?: string;
    /** 
     * 定額電灯（６）（電灯）：半角数値(小数点なし)
     */
    teigakudento6Dento?: number;
    /** 
     * 定額電灯（６）（小型機器）：半角数値(小数点なし)
     */
    teigakudento6Kogatakiki?: number;
    /** 
     * 定額電灯（７）（ランク）：半角数字
     */
    teigakudento7Rank?: string;
    /** 
     * 定額電灯（７）（電灯）：半角数値(小数点なし)
     */
    teigakudento7Dento?: number;
    /** 
     * 定額電灯（７）（小型機器）：半角数値(小数点なし)
     */
    teigakudento7Kogatakiki?: number;
    /** 
     * 定額電灯（８）（ランク）：半角数字
     */
    teigakudento8Rank?: string;
    /** 
     * 定額電灯（８）（電灯）：半角数値(小数点なし)
     */
    teigakudento8Dento?: number;
    /** 
     * 定額電灯（８）（小型機器）：半角数値(小数点なし)
     */
    teigakudento8Kogatakiki?: number;
    /** 
     * 定額電灯（９）（ランク）：半角数字
     */
    teigakudento9Rank?: string;
    /** 
     * 定額電灯（９）（電灯）：半角数値(小数点なし)
     */
    teigakudento9Dento?: number;
    /** 
     * 定額電灯（９）（小型機器）：半角数値(小数点なし)
     */
    teigakudento9Kogatakiki?: number;
    /** 
     * 定額電灯（１０）（ランク）：半角数字
     */
    teigakudento10Rank?: string;
    /** 
     * 定額電灯（１０）（電灯）：半角数値(小数点なし)
     */
    teigakudento10Dento?: number;
    /** 
     * 定額電灯（１０）（小型機器）：半角数値(小数点なし)
     */
    teigakudento10Kogatakiki?: number;
    /** 
     * 需要者氏名（カナ）：半角カナ
     */
    juyoshaShimeiKana?: string;
    /** 
     * 需要者氏名（漢字）：全角文字
     */
    juyoshaShimeiKanji?: string;
    /** 
     * 需要者電話番号（１）（区分）：半角英数混在
     */
    juyoshaTel1Kbn?: string;
    /** 
     * 需要者電話番号（１）（区分）名称：全角半角混在
     */
    juyoshaTel1KbnMeisho?: string;
    /** 
     * 需要者電話番号（１）：電話番号(ハイフンと数値含む)
     */
    juyoshaTel1?: string;
    /** 
     * 需要者電話番号（２）（区分）：半角英数混在
     */
    juyoshaTel2Kbn?: string;
    /** 
     * 需要者電話番号（２）（区分）名称：全角半角混在
     */
    juyoshaTel2KbnMeisho?: string;
    /** 
     * 需要者電話番号（２）：電話番号(ハイフンと数値含む)
     */
    juyoshaTel2?: string;
    /** 
     * 供給地点郵便番号：半角数字
     */
    kykyChtnYubimno?: string;
    /** 
     * 供給地点住所：全角文字
     */
    jusho?: string;
    /** 
     * 建物名：全角半角混在
     */
    tatemono?: string;
    /** 
     * 計器番号（１）：半角英数混在
     */
    keikiNo1?: string;
    /** 
     * 計器番号（１）容量：半角数値(小数点なし)
     */
    keikiNo1Yoryo?: number;
    /** 
     * 計器番号（１）３０分値収集可否・自動検針可否：半角英数混在
     */
    keikiNo130minJidoKenshinKahi?: string;
    /** 
     * 計器番号（１）３０分値収集可否・自動検針可否名称：全角半角混在
     */
    keikiNo130minJidoKenshinKahiMeisho?: string;
    /** 
     * 計器番号（１）Ｂルート通信方式：半角英数混在
     */
    keikiNo1BRootTsushinHoshiki?: string;
    /** 
     * 計器番号（１）Ｂルート通信方式名称：全角半角混在
     */
    keikiNo1BRootTsushinHoshikiMeisho?: string;
    /** 
     * 計器番号（２）：半角英数混在
     */
    keikiNo2?: string;
    /** 
     * 計器番号（２）容量：半角数値(小数点なし)
     */
    keikiNo2Yoryo?: number;
    /** 
     * 計器番号（２）３０分値収集可否・自動検針可否：半角英数混在
     */
    keikiNo230minJidoKenshinKahi?: string;
    /** 
     * 計器番号（２）３０分値収集可否・自動検針可否名称：全角半角混在
     */
    keikiNo230minJidoKenshinKahiMeisho?: string;
    /** 
     * 計器番号（２）Ｂルート通信方式：半角英数混在
     */
    keikiNo2BRootTsushinHoshiki?: string;
    /** 
     * 計器番号（２）Ｂルート通信方式名称：全角半角混在
     */
    keikiNo2BRootTsushinHoshikiMeisho?: string;
    /** 
     * 計器番号（３）：半角英数混在
     */
    keikiNo3?: string;
    /** 
     * 計器番号（３）容量：半角数値(小数点なし)
     */
    keikiNo3Yoryo?: number;
    /** 
     * 計器番号（３）３０分値収集可否・自動検針可否：半角英数混在
     */
    keikiNo330minJidoKenshinKahi?: string;
    /** 
     * 計器番号（３）３０分値収集可否・自動検針可否名称：全角半角混在
     */
    keikiNo330minJidoKenshinKahiMeisho?: string;
    /** 
     * 計器番号（３）Ｂルート通信方式：半角英数混在
     */
    keikiNo3BRootTsushinHoshiki?: string;
    /** 
     * 計器番号（３）Ｂルート通信方式名称：全角半角混在
     */
    keikiNo3BRootTsushinHoshikiMeisho?: string;
    /** 
     * 計器番号（４）：半角英数混在
     */
    keikiNo4?: string;
    /** 
     * 計器番号（４）容量：半角数値(小数点なし)
     */
    keikiNo4Yoryo?: number;
    /** 
     * 計器番号（４）３０分値収集可否・自動検針可否：半角英数混在
     */
    keikiNo430minJidoKenshinKahi?: string;
    /** 
     * 計器番号（４）３０分値収集可否・自動検針可否名称：全角半角混在
     */
    keikiNo430minJidoKenshinKahiMeisho?: string;
    /** 
     * 計器番号（４）Ｂルート通信方式：半角英数混在
     */
    keikiNo4BRootTsushinHoshiki?: string;
    /** 
     * 計器番号（４）Ｂルート通信方式名称：全角半角混在
     */
    keikiNo4BRootTsushinHoshikiMeisho?: string;
    /** 
     * 計器番号（５）：半角英数混在
     */
    keikiNo5?: string;
    /** 
     * 計器番号（５）容量：半角数値(小数点なし)
     */
    keikiNo5Yoryo?: number;
    /** 
     * 計器番号（５）３０分値収集可否・自動検針可否：半角英数混在
     */
    keikiNo530minJidoKenshinKahi?: string;
    /** 
     * 計器番号（５）３０分値収集可否・自動検針可否名称：全角半角混在
     */
    keikiNo530minJidoKenshinKahiMeisho?: string;
    /** 
     * 計器番号（５）Ｂルート通信方式：半角英数混在
     */
    keikiNo5BRootTsushinHoshiki?: string;
    /** 
     * 計器番号（５）Ｂルート通信方式名称：全角半角混在
     */
    keikiNo5BRootTsushinHoshikiMeisho?: string;
    /** 
     * 引込柱番号：全角半角混在
     */
    hikikomiChuNo?: string;
    /** 
     * 供給方式：半角英数混在
     */
    kyokyuHoshiki?: string;
    /** 
     * 供給方式名称：全角半角混在
     */
    kyokyuHoshikiMeisho?: string;
    /** 
     * 廃止措置方法：半角英数混在
     */
    haishiSochiHoho?: string;
    /** 
     * 廃止措置方法名称：全角半角混在
     */
    haishiSochiHohoMeisho?: string;
    /** 
     * 接続供給廃止日：日付YYYYMMDD
     */
    setsuzokuKyokyuHaishiDay?: string;
    /** 
     * 基本検針日：日付YYYYMMDD
     */
    basicKensinDay?: string;
    /** 
     * 前回検針日：日付YYYYMMDD
     */
    zenkaiKenshinYmd?: string;
    /** 
     * 次回検針日：日付YYYYMMDD
     */
    jikaiKenshinYmd?: string;
    /** 
     * 次々回検針日：日付YYYYMMDD
     */
    jijikaiKenshinYmd?: string;
    /** 
     * ご連絡先（区分）：半角英数混在
     */
    renrakuKbn?: string;
    /** 
     * ご連絡先（区分）名称：全角半角混在
     */
    renrakuKbnMeisho?: string;
    /** 
     * ご連絡先氏名（カナ）：半角カナ
     */
    renrakuShimeiKana?: string;
    /** 
     * ご連絡先氏名（漢字）：全角文字
     */
    renrakuShimeiKanji?: string;
    /** 
     * ご連絡先電話番号（区分）：半角英数混在
     */
    renrakuTelKbn?: string;
    /** 
     * ご連絡先電話番号（区分）名称：全角半角混在
     */
    renrakuTelKbnMeisho?: string;
    /** 
     * ご連絡先電話番号：電話番号(ハイフンと数値含む)
     */
    renrakuTel?: string;
    /** 
     * ご連絡先郵便番号：半角数字
     */
    renrakuYubinNo?: string;
    /** 
     * ご連絡先住所：全角文字
     */
    renrakuJusho?: string;
    /** 
     * ご連絡先建物名：全角半角混在
     */
    renrakuTatemono?: string;
    /** 
     * 過去新設異動年月日：日付YYYYMMDD
     */
    kakoShinsetsuIdoYmd?: string;
    /** 
     * 過去増設異動年月日：日付YYYYMMDD
     */
    kakoZosetsuIdoYmd?: string;
    /** 
     * 異動申込受付（１）年月日：日付YYYYMMDD
     */
    idoumoshikomiacept1Yearmonthdate?: string;
    /** 
     * 異動申込受付（１）申込種別：半角英数混在
     */
    idoumoshikomiacept1Srnclsfy?: string;
    /** 
     * 異動申込受付（１）申込種別名称：全角半角混在
     */
    idoumoshikomiacept1Srnclsfyaname?: string;
    /** 
     * 異動申込受付（１）工程：半角英数混在
     */
    idoumoshikomiacept1Kotei?: string;
    /** 
     * 異動申込受付（１）工程名称：全角半角混在
     */
    idoumoshikomiacept1Koteianame?: string;
    /** 
     * 異動申込受付（２）年月日：日付YYYYMMDD
     */
    idoumoshikomiacept2Yearmonthdate?: string;
    /** 
     * 異動申込受付（２）申込種別：半角英数混在
     */
    idoumoshikomiacept2Srnclsfy?: string;
    /** 
     * 異動申込受付（２）申込種別名称：全角半角混在
     */
    idoumoshikomiacept2Srnclsfyaname?: string;
    /** 
     * 異動申込受付（２）工程：半角英数混在
     */
    idoumoshikomiacept2Kotei?: string;
    /** 
     * 異動申込受付（２）工程名称：全角半角混在
     */
    idoumoshikomiacept2Koteianame?: string;
    /** 
     * 異動申込受付（３）年月日：日付YYYYMMDD
     */
    idoumoshikomiacept3Yearmonthdate?: string;
    /** 
     * 異動申込受付（３）申込種別：半角英数混在
     */
    idoumoshikomiacept3Srnclsfy?: string;
    /** 
     * 異動申込受付（３）申込種別名称：全角半角混在
     */
    idoumoshikomiacept3Srnclsfyaname?: string;
    /** 
     * 異動申込受付（３）工程：半角英数混在
     */
    idoumoshikomiacept3Kotei?: string;
    /** 
     * 異動申込受付（３）工程名称：全角半角混在
     */
    idoumoshikomiacept3Koteianame?: string;
    /** 
     * 異動申込受付（４）年月日：日付YYYYMMDD
     */
    idoumoshikomiacept4Yearmonthdate?: string;
    /** 
     * 異動申込受付（４）申込種別：半角英数混在
     */
    idoumoshikomiacept4Srnclsfy?: string;
    /** 
     * 異動申込受付（４）申込種別名称：全角半角混在
     */
    idoumoshikomiacept4Srnclsfyaname?: string;
    /** 
     * 異動申込受付（４）工程：半角英数混在
     */
    idoumoshikomiacept4Kotei?: string;
    /** 
     * 異動申込受付（４）工程名称：全角半角混在
     */
    idoumoshikomiacept4Koteianame?: string;
    /** 
     * 異動申込受付（５）年月日：日付YYYYMMDD
     */
    idoumoshikomiacept5Yearmonthdate?: string;
    /** 
     * 異動申込受付（５）申込種別：半角英数混在
     */
    idoumoshikomiacept5Srnclsfy?: string;
    /** 
     * 異動申込受付（５）申込種別名称：全角半角混在
     */
    idoumoshikomiacept5Srnclsfyaname?: string;
    /** 
     * 異動申込受付（５）工程：半角英数混在
     */
    idoumoshikomiacept5Kotei?: string;
    /** 
     * 異動申込受付（５）工程名称：全角半角混在
     */
    idoumoshikomiacept5Koteianame?: string;
    /** 
     * 他契約形態（１）供給地点特定番号：半角英数混在
     */
    takeiyakukeitai1KyokyuChitenTokuteiNo?: string;
    /** 
     * 他契約形態（１）：半角英数混在
     */
    takeiyakukeitai1?: string;
    /** 
     * 他契約形態（１）名称：全角半角混在
     */
    takeiyakukeitai1Meisho?: string;
    /** 
     * 他契約形態（２）供給地点特定番号：半角英数混在
     */
    takeiyakukeitai2KyokyuChitenTokuteiNo?: string;
    /** 
     * 他契約形態（２）：半角英数混在
     */
    takeiyakukeitai2?: string;
    /** 
     * 他契約形態（２）名称：全角半角混在
     */
    takeiyakukeitai2Meisho?: string;
    /** 
     * 太陽光、自家発などの系統連系設備：半角英数混在
     */
    taiyokoJikahatsuKeitoRenkeiSetsubi?: string;
    /** 
     * 太陽光、自家発などの系統連系設備名称：全角半角混在
     */
    taiyokoJikahatsuKeitoRenkeiSetsubiMeisho?: string;
}
